// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__VhZnD","detailsBorder":"styles_detailsBorder__1XTBW"};